import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class GheymatMantegheiModel extends BaseModel {
  RouteName = "GheymatManteghei";
  protected AuthState: boolean = true;

  public async GetSearch(CatTitle = "", Shomal = "", Shargh = "", Jnoob = "", Gharb = "", TitleRadif = "", MetrajMaabar = "") {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(
          `${this.RouteName}/search?CatTitle=${CatTitle}&Shomal=${Shomal}&Shargh=${Shargh}&Jnoob=${Jnoob}&Gharb=${Gharb}&TitleRadif=${TitleRadif}&MetrajMaabar=${MetrajMaabar}`
        );
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
}
